// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__l5dEk","error":"Textarea_error__3HtSp","readonly":"Textarea_readonly__22Mtv","disabled":"Textarea_disabled__229JV"};